export default __webpack_public_path__ + "media/images/brighteon-social/Icon-NewPost-White-141edeb7c3cdb170636d543463a0d80f.svg";